import { Component, Inject } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LoadingService, Lists } from '../../services';
import { Observable } from 'rxjs';
import { ListApiService } from '../../services/api';
import { SiModalModule } from '../si-modal';
import { AsyncPipe } from '@angular/common';

const LOADING_TAG: string = 'make-lists-public-prompt-loader';

@UntilDestroy()
@Component({
  selector: 'make-lists-public-prompt',
  templateUrl: './make-lists-public-prompt.component.html',
  styleUrls: ['./make-lists-public-prompt.component.scss'],
  imports: [
    SiModalModule,
    AsyncPipe,
  ],
  standalone: true,
})
export class MakeListsPublicPromptComponent {
    isLoading$: Observable<boolean>;

    constructor(
        @Inject(MAT_DIALOG_DATA) public initialState: any,
        private readonly matDialogRef: MatDialogRef<MakeListsPublicPromptComponent>,
        private listsService: Lists,
        private readonly listApiService: ListApiService,
        private readonly loadingService: LoadingService,
    ) {
        this.isLoading$ = this.loadingService.getIsLoading(LOADING_TAG);
    }

    private handleListPrivacyUpdate() {
        this.loadingService.loadingWrapper(this.listApiService.updateListsPrivacy(this.initialState.privateListIds?.join(',')), LOADING_TAG)
            .pipe(untilDestroyed(this))
            .subscribe(
                () => {
                    this.listsService.refreshLists();
                    this.matDialogRef.close({
                        success: true,
                    });
                },
                () => {
                    this.matDialogRef.close();
                }
            );
    }

    onConfirmation(isConfirm: boolean) {
        if (isConfirm) {
            this.initialState.type === 'increaseListPrivacy' ? this.handleListPrivacyUpdate() : this.matDialogRef.close();
        } else {
            this.matDialogRef.close();
        }
    }
}
